// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"PU-z","inlineTitle":"QU-z","sponsoredAdsWrapper":"RU-z","marketplaceRecosWrapper":"SU-z"};